import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import { connect } from "react-redux";
import { Alert, Layout, Input, Table, Select } from "antd";

import classes from "./Inventory.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getDrugManagementSitesRequest,
  getInventoryRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getDrugAccessPermissionDrugManagement,
  getDrugAllowTransferFromFridgeToPatient,
  getUserTimezone,
} from "../../reducers/user/selectors";

import mapped_statuses from "../../data/mappedStatus";
import { withNamespaces } from "react-i18next";

const { Content } = Layout;
const { Option } = Select;

class Inventory extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      drugs: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      site: null,
      filter: null,
      order: "asc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      approvedSelected: null,
      statusFilters: [],
      sitesFilter: [],
      filtersValue: [],
      filtersBy: ["location", "drug_status"],
    };
  }

  async componentDidMount() {
    this.onNameSearch();
    this.getSitesList();
  }

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filterBy: null,
        filterValue: null,
        eventsSelected: {},
        currentPage: 1
      },
      this.getInventory
    );
  };

  clearFilters = () => {
    this.setState({ filtersValue: [], currentPage: 1 }, this.getInventory);
  };

  getInventory = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getInventoryRequest({
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
      });

      this.setState({
        drugs: map(data.data, (item, index) => ({ ...item, index })),
        total: data.total,
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        drugs: null,
        errorMessage: get(e, "response.data.error", this.props.i18n.t("Error")),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getDrugs(pagination.current, pagination.pageSize)
    );
  };

  getSitesList = async () => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getDrugManagementSitesRequest();
      this.setState({
        sitesListFrom: get(data, "from").map((site) => ({
          value: get(site, "id"),
          label: get(site, "name"),
        })),
        sitesListTo: get(data, "to").map((site) => ({
          value: get(site, "id"),
          label: get(site, "name"),
        })),
        sitesFilter: get(data, "filter").map((site) => ({
          value: get(site, "id"),
          label: get(site, "name"),
        })),
        statusFilters: get(data, "statuses"),
        // dispensingSites: data.filter(site => get(site, 'site_type') === 'dispensing').map(site => ({ value: get(site, 'id'), label: get(site, 'name')})),
        // centralSites: data.filter(site => get(site, 'site_type') === 'central_pharmacy').map(site => ({ value: get(site, 'id'), label: get(site, 'name')}))
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", this.props.i18n.t("Error")),
      });
    }

    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 1000);
  };

  onChangeLocationFilter = (value) => {
    this.setState((state) => {
      const filtersValue = [...state.filtersValue];
      filtersValue[0] = value;

      return { filtersValue, currentPage: 1 };
    }, this.getInventory);
  };

  onChangeDrugStatusFilter = (value) => {
    this.setState((state) => {
      const filtersValue = [...state.filtersValue];
      filtersValue[1] = value;

      return { filtersValue, currentPage: 1 };
    }, this.getInventory);
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      drugs,
      filtersValue,
      sitesFilter,
      statusFilters,
    } = this.state;
    const { drugAccessPermissionDrugManagement } = this.props;

    let columns = [
      {
        dataIndex: "location",
        key: "location",
        title: this.props.i18n.t("NamespaceInventory:Location"),
        render: (val) => get(val, "name"),
      },
      {
        dataIndex: "drug_status",
        key: "drug_status",
        title: this.props.i18n.t("NamespaceInventory:Status"),
        render: (val) =>
          mapped_statuses(this.props.i18n)[val],
      },
      {
        dataIndex: "total",
        key: "total",
        title: this.props.i18n.t("NamespaceInventory:Total"),
      },
    ];

    if (drugAccessPermissionDrugManagement) {
      columns.unshift({
        dataIndex: "drug_type",
        key: "drug_type",
        title: this.props.i18n.t("NamespaceInventory:Drug type"),
        render: (val) => val ? val.replace(/_/g, " ") : '',
      });
    }

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceInventory:Drug Inventory")}
            </h3>

            <div className={classes.searchWrapper}>
              <div className={classes.wrapperLocationFilter}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t("NamespaceDrugsEditor:Filter by location")}
                </b>
                <br />
                <div>
                  <Select
                    style={{ width: "300px" }}
                    onChange={this.onChangeLocationFilter}
                    value={filtersValue[0]}
                  >
                    {sitesFilter.map((item) => (
                      <Option value={item.value} key={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>

              <div className={classes.wrapperLocationFilter}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t(
                    "NamespaceDrugsEditor:Filter by drug status"
                  )}
                </b>
                <br />
                <div>
                  <Select
                    style={{ width: "400px" }}
                    onChange={this.onChangeDrugStatusFilter}
                    value={filtersValue[1]}
                  >
                    {statusFilters.map((value) => (
                      <Option value={value} key={value}>
                        {
                          mapped_statuses(this.props.i18n)[value]
                        }
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>

              <span className={classes.clearButton} onClick={this.clearFilters}>
                {this.props.i18n.t("Clear")}
              </span>
            </div>

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {responseMessage && (
              <Alert
                type="success"
                message={responseMessage}
                className={classes.alert}
              />
            )}

            <Table
              columns={columns}
              dataSource={drugs}
              loading={isLoading}
              rowKey="index"
              onChange={this.handleTableChange}
              pagination={false}
            />

            {/*{isLoading && <Icon type="loading" />}*/}
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  drugAccessPermissionDrugManagement: getDrugAccessPermissionDrugManagement(
    state
  ),
  drugAllowTransferFromFridgeToPatient: getDrugAllowTransferFromFridgeToPatient(
    state
  ),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Inventory))
);



// WEBPACK FOOTER //
// ./src/containers/Inventory/Inventory.js